import { COLORS } from '../../../models/colors.types';
import { POSITIONS_HORIZONTAL } from '../../../models/positions.types';

export const PARAGRAPH_ALIGNMENTS = {
  left: POSITIONS_HORIZONTAL.left,
  center: POSITIONS_HORIZONTAL.center,
  right: POSITIONS_HORIZONTAL.right,
} as const;
export type ParagraphAlignment = (typeof PARAGRAPH_ALIGNMENTS)[keyof typeof PARAGRAPH_ALIGNMENTS];

export const PARAGRAPH_APPEARANCES = {
  body: 'body',
  caption: 'caption',
  display: 'display',
} as const;
export type ParagraphAppearance = (typeof PARAGRAPH_APPEARANCES)[keyof typeof PARAGRAPH_APPEARANCES];

export const PARAGRAPH_SIZES_BODY = {
  small: 'small',
  regular: 'regular',
  large: 'large',
} as const;
export type ParagraphSizeBody = (typeof PARAGRAPH_SIZES_BODY)[keyof typeof PARAGRAPH_SIZES_BODY];

export const PARAGRAPH_SIZES_CAPTION = {
  small: 'small',
  regular: 'regular',
} as const;
export type ParagraphSizeCaption = (typeof PARAGRAPH_SIZES_CAPTION)[keyof typeof PARAGRAPH_SIZES_CAPTION];

export const PARAGRAPH_SIZES_LEGACY = {
  bold: 'bold',
} as const;
export type ParagraphSizeLegacy = (typeof PARAGRAPH_SIZES_LEGACY)[keyof typeof PARAGRAPH_SIZES_LEGACY];

export const PARAGRAPH_SIZES = {
  ...PARAGRAPH_SIZES_BODY,
  ...PARAGRAPH_SIZES_CAPTION,
  ...PARAGRAPH_SIZES_LEGACY,
};
export type ParagraphSize = (typeof PARAGRAPH_SIZES)[keyof typeof PARAGRAPH_SIZES];

export const PARAGRAPH_COLORS = {
  default: COLORS.default,
  subtle: COLORS.subtle,
  subtlest: COLORS.subtlest,
  inverse: COLORS.inverse,
  accent: COLORS.accent,
} as const;
export type ParagraphColors = (typeof PARAGRAPH_COLORS)[keyof typeof PARAGRAPH_COLORS];
